import { autoSaveProject } from '__editor/components/roofsSelector/components/roofsSelectorSaveLoadProject/saveProject';
import { BackgroundActionTypes } from '__editor/panelsEditor/components/background/backgroundActionsConstants';
import { PanelsActionTypes } from '__editor/panelsEditor/components/panels/panelsActionsConstants';
import { DrawingManagerActionTypes } from '__editor/googleMapsRoofsSelector/components/drawingManager/drawingManagerActionsConstants';
import { getProductName } from '__common/constants/products';
import { shouldAutoSave } from '__editor/components/roofsSelector/components/roofsSelectorSaveLoadProject/utils/autosave';
import { ProjectConfigurationActionTypes } from 'projectDesign/components/projectConfiguration/projectConfigurationActionsConstants';
import { state } from '__common/store';
import { TiltedRoofActionTypes } from '__editor/panelsEditor/components/tiltedRoof/tiltedRoofActionsConstants';
import { panelsEditorEnabled } from 'projectDesign/projectDesign';

const PANEL_EDITOR_ACTIONS = [
  PanelsActionTypes.ADD_PANELS,
  PanelsActionTypes.REMOVE_PANELS,
];

const MANUAL_EXPOSURE_ACTIONS = [
  PanelsActionTypes.SET_MANUAL_EXPOSURE,
  PanelsActionTypes.SET_MANUAL_EXPOSURE_BULK,
  PanelsActionTypes.CLEAR_ALL_MANUAL_EXPOSURE,
];

export const saveProjectMiddleware = store => next => action => {
  if (!action) {
    console.error('saveProjectMiddleware: Action is undefined!');
    return;
  }

  if (typeof action !== 'object') {
    console.error('saveProjectMiddleware: Action is not an object:', typeof action, action);
    return;
  }

  if (action.type === undefined) {
    console.error('saveProjectMiddleware: Action type is undefined:', action);
    return;
  }

  next(action);

  const { projectConfiguration: { productId, projectId } } = state();
  const productName = getProductName(productId);
  const shouldAllowInPanelsEditor = PANEL_EDITOR_ACTIONS.includes(action.type) || panelsEditorEnabled() || MANUAL_EXPOSURE_ACTIONS.includes(action.type);
  const opts = shouldAllowInPanelsEditor ? { allowInPanelsEditor: true } : undefined;

  if (shouldSaveOnActions(action.type) && shouldAutoSave(opts)) {
    autoSaveProject(productName, projectId, opts);
  }
};

function shouldSaveOnActions(actionType) {
  const actions = [
    ProjectConfigurationActionTypes.SET_PROJECT_OPTION,
    ProjectConfigurationActionTypes.SET_PRODUCT_TITLE,
    ProjectConfigurationActionTypes.SET_ZIP_AND_ADDRESS_CODE,
    ProjectConfigurationActionTypes.SET_ENVIRONMENTAL_FACTORS,
    ProjectConfigurationActionTypes.SET_PROJECT_NAME,
    ProjectConfigurationActionTypes.SET_PROJECT_MODE,
    ProjectConfigurationActionTypes.SET_RAILS_PRODUCT_ID,
    ProjectConfigurationActionTypes.SET_SPAN,
    DrawingManagerActionTypes.DELETE_ROOF,
    DrawingManagerActionTypes.ADD_ROOF,
    DrawingManagerActionTypes.SET_ARRAY_NAME,
    BackgroundActionTypes.DEACTIVE_PANELS_EDITOR,
    DrawingManagerActionTypes.SET_ROOF_ROOF_PITCH,
    DrawingManagerActionTypes.SET_ROOF_ROW_SPACING,
    DrawingManagerActionTypes.SET_ROOF_TABLE_ROW_SPACING,
    PanelsActionTypes.UPDATE_PANEL_SPACINGS,
    PanelsActionTypes.CHANGE_DESIRED_TABLE_LENGTH,
    PanelsActionTypes.CHANGE_DESIRED_TABLE_WIDTH,
    PanelsActionTypes.UPDATE_PANELS,
    BackgroundActionTypes.PANELS_SET_ROTATION,
    BackgroundActionTypes.BACKGROUND_SET_LOW_EDGE_TO_ROOF,
    TiltedRoofActionTypes.SET_TILTED_ROOF_STRUCTURE_TILT,
    ProjectConfigurationActionTypes.CHANGE_STRUCTURE_TYPE,
    ProjectConfigurationActionTypes.CHANGE_STRUCTURE_TYPE_TILT,
    ProjectConfigurationActionTypes.CHANGE_STRUCTURE_TYPE_PREFERRED_SPAN,
    ...MANUAL_EXPOSURE_ACTIONS,
  ];

  return actions.includes(actionType);
}
